import React from "react";

const Link = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M3.455 14.591h4.363v17.742H3.455c-.386 0-.756-.155-1.029-.433A1.491 1.491 0 012 30.855V16.07c0-.392.153-.768.426-1.046a1.443 1.443 0 011.029-.433zm7.698-1.911l9.31-9.463a.722.722 0 01.95-.07l1.241.947c.345.263.605.624.749 1.037.143.413.162.86.056 1.284l-1.677 6.698h9.309c.771 0 1.511.311 2.057.866.545.555.852 1.307.852 2.09v3.112c0 .386-.074.769-.218 1.126L29.28 31.418c-.11.271-.296.503-.536.666-.24.162-.521.25-.81.25H12.182c-.386 0-.756-.156-1.029-.434a1.49 1.49 0 01-.426-1.045v-17.13c0-.392.154-.768.426-1.045z"
            fill={fill}
        />
    </svg>
);

export default Link;
